module.exports = __webpack_public_path__ + "img/Mstorybg203.f80bed3e.png";